<app-cvs-mdp-header *ngIf="showHeaderFooter && !showGlobalHeader"></app-cvs-mdp-header>
<cvs-header-component *ngIf="showGlobalHeader" search-bar-visible="true" spanish-visible="true"
                      target-component="uiview-sd,main-container-sd" page-name="" service-props="should_get_cart=false"></cvs-header-component>
<div id="uiview-sd" class="main-container-sd" tabindex="-1">
  <router-outlet></router-outlet>
</div>
<app-cvs-mdp-footer *ngIf="showHeaderFooter"></app-cvs-mdp-footer>
<app-cvs-mdp-spinner></app-cvs-mdp-spinner>
